/** Known values of {@link SortOrder} that the service accepts. */
export var KnownSortOrder;
(function (KnownSortOrder) {
    KnownSortOrder["Ascending"] = "Ascending";
    KnownSortOrder["Descending"] = "Descending";
})(KnownSortOrder || (KnownSortOrder = {}));
